import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import pt from 'vuetify/lib/locale/pt';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { pt },
        current: 'pt',
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                // New UI Kit colors
                primary: "#6C63FF", // Purple from UI Kit
                secondary: "#A5A6F6", // Light Purple from UI Kit
                background: "#F5F6FA", // Light Gray from UI Kit
                surface: "#FFFFFF", // White from UI Kit
                error: "#FF5252", // Red from UI Kit
                green: "#00C853", // Green from UI Kit

                // Event Colors
                "event-attended": "#00C853",
                "event-missed": "#FF5252",
                "event-rescheduled": "#FFC107",
                "event-scheduled": "#6C63FF",
                "event-extra": "#A5A6F6",
                "event-payment-pending": "#FF9800",
                "event-birthday": "#FF4081",
                "event-predicted": "#9E9E9E",

                // Legacy colors for backward compatibility
                "primary-blue": "#6C63FF", // Mapped to new primary
                "primary-pink": "#A5A6F6", // Mapped to new secondary
                "primary-gray": "#F5F6FA", // Mapped to background
                "primary-white": "#FFFFFF", // Mapped to surface

                "secondary-pink": "#b79ea1",
                "secondary-blue": "#5c7b8a",
                "secondary-gray": "#d8d8d8",
                "secondary-orange": "#f0d1b5",
                "secondary-green": "#9dbcc1",
                "secondary-purple": "#c9b6c6",
                "secondary-yellow": "#f1e3c6",
                "secondary-red": "#d87c7b",

                "tertiary-gray": "#a5a5a5",
                "tertiary-red": "#aa4d4c",

                "blue": "#546475",
                "orange": "#91471D",
                "tertiary": "#589fa4",
            }
        }
    }
});